import React, { useRef, useState , useEffect} from 'react';
import StructureSelector from './StructureSelector/StructureSelector.js';
import StructureInfo from './ProteinViewer/StructureInfo.js';
import ProteinViewer from './ProteinViewer/ProteinViewer.js';
import Settings from './Settings/settings.js';
import { useEnzymeStructureRemote } from '../../hooks/UseEnzymeStructureRemote.js';
import StatsBox from '../StatsPage/StatsBox.js'; 
import './StructureLayout.css';

const StructureBlock = ({ enzymeMarts, motifs, navigateToRecord }) => {

    const viewerRef  = useRef(); 
    const surfaceRef = useRef(); 


  const [isSurfaceShown, setIsSurfaceShown] = useState(false);
  const [currentStyle, setCurrentStyle] = useState('cartoon');
  const [opacity, setOpacity] = useState(0.5);
  const [currentColor, setCurrentColor] = useState('MediumBlue');
  const [activeMotifs, setActiveMotifs] = useState([]);
  const [showMotifSideChains, setShowMotifSideChains] = useState(false);
  const [colorByPlddt, setColorByPlddt] = useState(false);
  const [chains, setChains] = useState([]);


  const [activeLigands, setActiveLigands] = useState([])

  const {
    availableStructures,
    selectedStructure,
    setSelectedStructure,
    hasStructure,
    setHasStructure
  } = useEnzymeStructureRemote(enzymeMarts);

  useEffect(()=> {
    setActiveLigands([])
    setChains([])
    setColorByPlddt(selectedStructure?.type === 'Predicted');
  }, [selectedStructure])

  useEffect(() => {
    if (activeMotifs.length > 0) setColorByPlddt(false);
  }, [activeMotifs])



  // The section only appears once /searchstructures has reported at least one
  // structure. That is a single fast query now that the files are no longer
  // pre-fetched, so there is no long invisible period to cover; the per-file
  // wait is shown by ProteinViewer's own "Loading structure..." overlay.
  if (!hasStructure) return null;

    return (
        <StatsBox title="Structure">
        {availableStructures.length > 0 && (
            <StructureSelector
                structures={availableStructures}
                selectedPath = {selectedStructure?.path }
                onSelect = {setSelectedStructure}
                />)}

            <StructureInfo
        selectedStructure={selectedStructure}
        hasStructure={hasStructure}
      />

      <div className="structure-split">
        <div className="viewer-panel">
          <ProteinViewer
            viewerRef={viewerRef}
            surfaceRef={surfaceRef}
            setIsSurfaceShown={setIsSurfaceShown}
            currentStyle={currentStyle}
            currentColor={currentColor}
            selectedStructure={selectedStructure}
            activeLigands={activeLigands}
            hasStructure={hasStructure}
            setHasStructure={setHasStructure}
            activeMotifs={activeMotifs}
            showMotifSideChains={showMotifSideChains}
            colorByPlddt={colorByPlddt}
            setChains={setChains}
            motifs={motifs}
          />
        </div>
        <div className="settings-panel">
          <Settings
            viewerRef={viewerRef}
            surfaceRef={surfaceRef}
            isSurfaceShown={isSurfaceShown}
            setIsSurfaceShown={setIsSurfaceShown}
            currentStyle={currentStyle}
            setCurrentStyle={setCurrentStyle}
            opacity={opacity}
            setOpacity={setOpacity}
            currentColor={currentColor}
            activeMotifs={activeMotifs}
            setActiveMotifs={setActiveMotifs}
            motifs={motifs}
            hasStructure={hasStructure}
            ligands={selectedStructure?.ligands || []}
            activeLigands={activeLigands}
            setActiveLigands={setActiveLigands}
            showMotifSideChains={showMotifSideChains}
            setShowMotifSideChains={setShowMotifSideChains}
            navigateToRecord={navigateToRecord}
            isPredicted={selectedStructure?.type === 'Predicted'}
            colorByPlddt={colorByPlddt}
            setColorByPlddt={setColorByPlddt}
            chains={chains}
          />
        </div>
      </div>
    </StatsBox>
  );
};

export default StructureBlock;